export const isSomeEnum = <TEnum extends Record<string, unknown>>(e: TEnum, token: unknown) =>
  Object.values(e).includes(token)
